import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { Row, Select } from "antd";

import CommissionApi from "../../../../apis/Commission.api";

const CooperatePickInfluencer = ({
  isDisabled,
  selectInfluencer,
  setSelectInfluencer,
}) => {
  const isLoading = useSelector((state) => state.common.loading);

  const [influencerList, setInfluencerList] = useState([]);
  const [optionList, setOptionList] = useState([]);

  useEffect(() => {
    getInfluencerList();
  }, []);

  /**
   * 인플루언서 리스트 가져오기
   * @returns {Promise<void>}
   */
  const getInfluencerList = async () => {
    const param = {
      page: "cooperate",
    };
    const res = await CommissionApi.readCooperateInfluencerList(param);
    if (res.code === 200) {
      setInfluencerList([
        ...res.result.map((item) => ({
          id: item.id,
          label: item.nickname,
        })),
        {
          id: 2,
          label: "당신의 영양제",
        },
      ]);
      setOptionList([
        // eslint-disable-next-line no-unsafe-optional-chaining
        ...res.result.map((item) => ({
          value: item.id,
          label: item.nickname,
        })),
        {
          value: 2,
          label: "당신의 영양제",
        },
      ]);
    }
  };

  return (
    <>
      <Row className="product-register-border-box" wrap={false}>
        <span className="product-register-box-title">인플루언서 선택</span>
        <span className="product-register-box-sign">*</span>
      </Row>
      <Row
        className="product-register-border-box"
        wrap={false}
        style={{ borderTop: 0, width: "100%" }}
      >
        <Select
          defaultValue={selectInfluencer?.nickname}
          value={selectInfluencer.id ? selectInfluencer.id : null}
          onChange={(value) => {
            const list = influencerList?.filter((item) => item.id === value);
            setSelectInfluencer({ ...list[0] });
          }}
          style={{ width: 200, textAlign: "left", color: "#117ffa" }}
          placeholder={"인플루언서 선택"}
          options={optionList}
          loading={isLoading}
          disabled={isLoading || isDisabled}
        />
      </Row>
    </>
  );
};

export default CooperatePickInfluencer;
